<template>
<div class="chapter">
<div class="inner_page">
<a id="page_2"></a>
<p class="dedi"><span class="bold">Dedication</span></p>
<p class="dedi1">To my parents Dot and Len, who taught me to draw, and showed me the light and the magic.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedication.vue?312a462c